<template>
  <div>
    <chat-items :userId="userId" 
                :chatItems="items" 
                :contactName="contactName" 
                :dialog="dialog"
                @sendMessage="sendMessage" 
                @closeDialog="closeDialog"> 
    </chat-items>
  </div>
</template>

<script lang="ts">
import ChatItem from '@/generated/classes/ChatItem';
import { storeChat, storeContact, storeSession } from '@/generated/stores';
import ChatItems from '@/framework/chat/components/ChatItems.vue';
import Chat from '@/generated/classes/Chat';
import { ObjTypes } from '@/generated/classes/ObjTypes';
import { defineComponent, PropType } from "vue";

export default defineComponent({
  components: {
    ChatItems
  },
  props: {
    data: {
      type: Object as PropType<any>
    },
    objType: {
      type: Object as PropType<ObjTypes>,
      required: true
    },
    objId: {
      type: Number
    },
    dialog: {
      type: Boolean
    },
    id: {
      type: Number
    }
  },
  data() {
    const chatItems: ChatItem[] = [];

    return {
      userId: 0,
      chatId: 0,
      lastObjId: 0,
      contactName: '',
      chatItems
    };
  },
  computed: {
    items(): ChatItem[] {
      this.initialise();
      return this.chatItems;
    }
  },
  beforeUnmount(): void {
    if (storeSession.hubCx) {
      storeSession.hubCx.off('chatItemCreated');
    }
  },
  methods: {
    initialise(): void {
      if ((this.id && this.id != this.chatId) || this.data && this.data.id != this.lastObjId) {
        this.chatItems = [];
        if (this.data && this.data.id) {
          this.lastObjId = this.data.id;
        }
        if (storeSession.connectedUser) {
          this.userId = storeSession.connectedUser.id;
        }
        const chat = new Chat();
        chat.objId = this.data && this.data.id ? this.data.id : this.objId;
        chat.objType = this.objType;
        Chat.load(chat).then((res: Chat) => {
          this.chatId = res.id;
          if (res.items) {
            res.items.forEach((item) => {
              this.chatItems.push(item);
            })
          }
          const user = res.user1 == this.userId ? res.user2 : res.user1;
          const contact = storeContact.getContact(user);
          this.contactName = contact.prenom + ' ' + contact.nom;
        })

        if (storeSession.hubCx) {
          storeSession.hubCx.invoke('EnterChat', storeSession.httpToken);
          storeSession.hubCx.on('chatItemCreated', (obj: ChatItem) => { this.chatItemcreated(obj) });
        }
      }
    },
    chatItemcreated(chatItem: ChatItem): void {
      this.chatItems.push(chatItem);
      const id = this.objId ? this.objId : this.data.id;
      const chat = storeChat.listChat.find(a => a.objId == id && a.objType == this.objType);
      if (storeSession.hubCx && chat) {
        storeSession.hubCx.invoke('ChatItemRead', storeSession.httpToken, chat);
      }
    },
    sendMessage(message: string): void {
      const item = new ChatItem();
      item.chatId = this.chatId;
      item.contactId = this.userId;
      item.date = new Date();
      item.label = message;
      if (storeSession.hubCx) {
        storeSession.hubCx.invoke('ChatCreateItem', storeSession.httpToken, item);
        this.$emit('itemCreated')
      }
      this.chatItems.push(item);
    },
    closeDialog() {
      this.$emit('closeDialog')
    }
  }
})

</script>

<style scoped>
  .sender-text {
    color: white;
    text-align: end;
    margin-bottom: 0;
  }

  .receiver-text {
    color: black;
    text-align: start;
    margin-bottom: 0;
  }

  .sender {
    position: relative;
    background: rgb(0, 120, 254);
    border-radius: 10px;
    margin-right: 10px;
    padding: 10px;
  }

    .sender:after {
      content: '';
      position: absolute;
      right: 0;
      top: 50%;
      width: 0;
      height: 0;
      border: 20px solid transparent;
      border-left-color: rgb(0, 120, 254);
      border-right: 0;
      border-bottom: 10px solid transparent;
      ;
      border-top: 10px solid transparent;
      margin-top: -10px;
      margin-right: -20px;
    }

  .receiver {
    position: relative;
    background: #EEE;
    border-radius: 10px;
    margin-left: 10px;
    padding: 10px;
  }

    .receiver:after {
      content: '';
      position: absolute;
      left: 0;
      top: 45%;
      width: 0;
      height: 0;
      border: 20px solid transparent;
      border-right-color: #EEE;
      border-top: 10px solid transparent;
      border-left: 0;
      border-bottom: 10px solid transparent;
      margin-top: -10px;
      margin-left: -20px;
    }
</style>